module.exports = __webpack_public_path__ + "img/new_index_cooperate_bg1.f3fb3a21.png";